module.exports = __webpack_public_path__ + "static/media/SR-tool-w.b1c6b1c6.png";